// components
import { Grid } from '@mui/material';
import { fontWeight, Heading, headingLevel, Text, textLevel, Tooltip } from '../../../../../packages';

import { useSelector } from 'react-redux';
import { getProfile } from '../../../../../redux/modules/profile/selectors';

// styles
import { useStyles } from '../../MemberDetail.styles';

const PreferredPharmacy = ({ memberId }) => {
  const { demographicDetails = {} } = useSelector(getProfile);
  const classes = useStyles({});

  const renderInfo = (label, text) => {
    return (
      <Grid item md={1} xs={3}>
        <div className={classes.fieldContainer}>
          <Text className={classes.textLight} level={textLevel.S} weight={fontWeight.SEMI_BOLD}>
            {label}
          </Text>
          <Text className={classes.fieldValue} level={textLevel.M} weight={fontWeight.MEDIUM}>
            {text?.length > 15 ? (
              <Tooltip title={text} placement="top-start">
                <span className={classes.fieldValue2}>{text}</span>
              </Tooltip>
            ) : (
              <span>{text}</span>
            )}
          </Text>
        </div>
      </Grid>
    );
  };

  return (
    <div className={classes.card}>
      <div className={classes.cardTopSection}>
        <Heading level={headingLevel.S} weight={fontWeight.BOLD}>
          Preferred Pharmacy
        </Heading>
      </div>
      <Grid className={classes.cardContentSection} container columns={2} rowSpacing="32px">
        {renderInfo('Pharmacy Name', demographicDetails.preferredPharmacyName || 'Not Specified')}
        {renderInfo('Zip Code', demographicDetails.preferredPharmacyZipCode || 'Not Specified')}
      </Grid>
    </div>
  );
};

export default PreferredPharmacy;
